var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyeCoveredSquared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-MyClients-documentList-gridView-(coach)",
    transform: "translate(-841.000000, -580.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 1470,
    height: 945
  }), /*#__PURE__*/React.createElement("g", {
    id: "btn-hide",
    transform: "translate(841.000000, 580.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-show",
    fill: "#F3F3F3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic-hide",
    transform: "translate(10.000000, 11.000000)",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9 C0,9 4.725,2.25 10.5,2.25 C16.2,2.25 21,9 21,9 C21,9 16.2,15.75 10.5,15.75 C4.8,15.75 0,9 0,9 L0,9 Z",
    id: "Stroke-303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,5.25 C12.57075,5.25 14.25,6.92925 14.25,9 C14.25,11.07075 12.57075,12.75 10.5,12.75 C8.42925,12.75 6.75,11.07075 6.75,9 C6.75,6.92925 8.42925,5.25 10.5,5.25 L10.5,5.25 Z",
    id: "Stroke-304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,18 L19.5,0",
    id: "Stroke-305"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeCoveredSquared);
export default __webpack_public_path__ + "static/media/ic-eye-covered-squared.be3c6f1e29c448619d6d64ee644e2e4b.svg";
export { ForwardRef as ReactComponent };